import { IconActions, IconDashboard, IconDevices, IconFindings, IconPolicy } from './icons';

// The one list the V3 side menu is made from: add a page here and it shows in the menu. `path` is under /v3.
export const navSections = [
  {
    label: 'Overview',
    items: [
      { label: 'Dashboard', path: '/v3/dashboard', icon: IconDashboard, bear: 'kongiDashboard' },
    ],
  },
  {
    label: 'Policy',
    items: [
      { label: 'Policies', path: '/v3/policies', icon: IconPolicy, bear: 'nuri' },
    ],
  },
  {
    label: 'Drift',
    items: [
      { label: 'Devices', path: '/v3/devices', icon: IconDevices, bear: 'gomi' },
      { label: 'Findings', path: '/v3/findings', icon: IconFindings, bear: 'bandal' },
      { label: 'Actions', path: '/v3/actions', icon: IconActions, bear: 'bongbong' },
    ],
  },
];

export const pageTitle = (pathname) => {
  const found = navSections.flatMap((s) => s.items).find((i) => pathname === i.path || pathname.startsWith(`${i.path}/`));
  return found ? found.label : 'Dashboard';
};
